var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "account", staticClass: "account" },
    [
      _c(
        "keep-alive",
        [
          _c(
            "router-view",
            [
              _c(
                "template",
                { slot: "my-bookings-header-grid" },
                [_vm._t("my-bookings-header-grid")],
                2
              ),
              _vm._v(" "),
              _c(
                "template",
                { slot: "my-bookings-grid" },
                [_vm._t("my-bookings-grid")],
                2
              ),
              _vm._v(" "),
              _c(
                "template",
                { slot: "booking-overview-grid" },
                [_vm._t("booking-overview-grid")],
                2
              ),
              _vm._v(" "),
              _c(
                "template",
                { slot: "my-details-grid" },
                [_vm._t("my-details-grid")],
                2
              ),
              _vm._v(" "),
              _c(
                "template",
                { slot: "passenger-details-grid" },
                [_vm._t("passenger-details-grid")],
                2
              ),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }